import React, { useEffect, useRef, useState } from "react"
import { BsInfoCircle } from "react-icons/bs"

const PasswordLabel: React.FC = () => {
	const [showTooltip, setShowTooltip] = useState<boolean>(false)
	const [clicked, setClicked] = useState<boolean>(false)
	const tooltipRef = useRef<HTMLDivElement | null>(null)
	const handleClick = () => {
		setClicked(!clicked)
		setShowTooltip(!clicked)
	}

	const handleMouseEnter = () => {
		if (!clicked) setShowTooltip(true)
	}

	const handleMouseLeave = () => {
		if (!clicked) setShowTooltip(false)
	}
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				tooltipRef.current &&
				!tooltipRef.current.contains(event.target as Node)
			) {
				setShowTooltip(false)
			}
		}
		document.addEventListener("mousedown", handleClickOutside)
		return () => {
			document.removeEventListener("mousedown", handleClickOutside)
		}
	}, [])
	return (
		<label className="flex items-center justify-start text-[14px] font-medium leading-5 text-gray-800">
			Password
			<span
				className="group relative pl-1"
				ref={tooltipRef}
				onClick={handleClick}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
			>
				<BsInfoCircle className="cursor-pointer text-gray-500" />
				<span
					className={`absolute left-6 top-0 z-10 w-64 rounded-md bg-white p-3 text-sm text-gray-800 shadow-md ring-1 ring-gray-200 ${
						showTooltip ? "block" : "hidden"
					}`}
				>
					<p className="mb-1 font-semibold text-black">
						Your password must include:
					</p>
					<ul className="list-disc pl-5 text-xs leading-snug">
						<li>At least 11 characters</li>
						<li>At least one number</li>
						<li>
							At least one special character. Allowed characters:
							<span className="break-all font-bold">
								{
									" ^ $ * . [ ] { } ( ) ? \" ! @ # % & / \\ , > < ' : ; | _ ~ ` = + -"
								}
							</span>
						</li>
						<li>At least one uppercase letter (A–Z)</li>
						<li>At least one lowercase letter (a–z)</li>
						<li>No leading or trailing spaces allowed</li>
					</ul>
				</span>
			</span>
		</label>
	)
}

export default PasswordLabel
